/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetRequest } from '../models';
import type { ResourceRef } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class AssetsControllerService {
    public static findAsset(requestBody: AssetRequest, options?: ApiRequestOptions): Promise<ApiResponse<ResourceRef>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/assets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
                404: `cannot find requested asset`,
            },
        });
    }
    public static findAssetNonEncrypted(
        requestBody: AssetRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<ResourceRef>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/assets/public',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
                404: `cannot find requested asset`,
            },
        });
    }
}
